import type { Language } from '$lib/lang';
import { SITE_LANGUAGES } from '$lib/lang';

export const match = (param: Language) => {
	return SITE_LANGUAGES.includes(param);
};
